import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchBilledAdsLmtdProps = {
  startDate: Moment;
  endDate: Moment;
  report: string;
};
export type FetchBilledAdsLmtd = (filters: FetchBilledAdsLmtdProps) => void;

const fetchBilledAdsLmtd = ({
  startDate,
  endDate,
  report
}: FetchBilledAdsLmtdProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport(report, dispatch, params);
};

export default fetchBilledAdsLmtd;
